
 <div id="header" class="header">
  <div class="banner-panel">
    <img class="banner-panel-logo" ngSrc="assets/images/logo.svg" width="117" height="143" alt="Siemens" />
    <img class="banner-panel-copy" ngSrc="assets/images/copy.svg" width="538" height="120" priority alt="Monte Carlo. Golden Eagle Club, March 15-20, 2027" />
  </div>
</div>
@if (showNav()) {
<nav class="navbar navbar-expand-lg navbar-light nav-bg">
  <div class="container-fluid">
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
      <ul class="navbar-nav mx-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link" 
            routerLink="/home" 
            routerLinkActive="active" 
            [routerLinkActiveOptions]="{exact: true}">Welcome</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" 
            routerLink="/destination" 
            routerLinkActive="active">Destination and Hotel Information</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" 
            routerLink="/agenda" 
            routerLinkActive="active">Agenda</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" 
            routerLink="/attire" 
            routerLinkActive="active">Attire</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" 
            routerLink="/activities" 
            routerLinkActive="active">Activities</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" 
            routerLink="/dining" 
            routerLinkActive="active">Dining</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" 
            routerLink="/travelGuide" 
            routerLinkActive="active">Travel Guide Summaries</a>
        </li>
        @if (version() === 'VIP'){
          <li class="nav-item">
            <a class="nav-link" href="assets/files/lsh_822672_Siemens_Golden_Eagle_Club_2027_Monte_Carlo_Travel_Guide_VIPs.pdf" target="_blank">Travel Guide</a>
          </li>
        } @else {
          <li class="nav-item">
            <a class="nav-link" href="assets/files/lsh_822672_Siemens_Golden_Eagle_Club_2027_Monte_Carlo_Travel_Guide_Qualifiers.pdf" target="_blank">Travel Guide</a>
          </li>
        }
        <li class="nav-item">
          <a class="nav-link" 
            routerLink="/faqs" 
            routerLinkActive="active">FAQs</a>
        </li>
        @if (version()) {
        <li class="nav-item">
          <button type="button" class="nav-link logout-link" (click)="logout()">Log Out</button>
        </li>
        }
      </ul>
    </div>
  </div>
</nav>
}